// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3wexF","tab":"Tabs_tab__3l-GE","tabActive":"Tabs_tabActive__3bOXr"};